import { render, staticRenderFns } from "./SfOverlay.vue?vue&type=template&id=10dbcf67&"
import script from "./SfOverlay.vue?vue&type=script&lang=js&"
export * from "./SfOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SfOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports